import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DEFAULTS = {
  hero_name: 'Cagatay',
  hero_surname: 'Turna',
  hero_subtitle: 'Insaat Yüksek Mühendisi | Yatirim ve Insaat Yonetimi',
  about_paragraph1: 'Yatirim ve insaat sektöründe deneyime sahip bir Insaat Yüksek Mühendisiyim. Proje yonetimi, ihale süreçleri, yapi denetimi ve kurumsal is takibi konularinda uzmanlasmis bulunmaktayim.',
  about_paragraph2: 'Istanbul Gençlik ve Spor Il Müdürlügü Yatirim ve Insaat Sube Müdürlügünde çalismaktayim. Istanbul Arel Üniversitesinde Insaat Mühendisligi üzerine Deprem Mühendisligi alaninda Doktora egitimime devam etmekteyim.',
  education: [
    { year: '2023 - Devam', deg: 'Doktora - Insaat Mühendisligi', school: 'Istanbul Arel Üniversitesi' },
    { year: '2019 - 2021', deg: 'Yüksek Lisans (Tezli) - Insaat Müh. (3.94/4)', school: 'Istanbul Aydin Üniversitesi' },
    { year: '2003 - 2007', deg: 'Lisans - Insaat Mühendisligi', school: 'Dumlupinar Üniversitesi' },
  ],
  expertise: [
    { title: 'Yapi Denetimi ve Kontrollük', desc: 'Spor tesisleri, yurt binalari ve kamu yapilarinin kontrollügü ve is programi takibi' },
    { title: 'Ihale ve Mevzuat', desc: '4734 sayili KIK, yapim ihaleleri, hakedis, yaklasik maliyet ve sözlesme yönetimi' },
    { title: 'Deprem Performans Analizi', desc: 'TBDY 2018 kapsaminda mevcut yapilarin performans degerlendirmesi ve güçlendirme' },
    { title: 'Dijital Dönüsüm', desc: 'Is süreçlerinin dijitallestirmesi ve Kurumsal Is Yönetimi Platformu gelistirme' },
  ],
  technical_software: ['SAP2000','ETABS','Prota Structure','ideCAD','AutoCAD','MS Office (Ileri)','OSKA/AMP Hakedis','Nivo','XTRACT'],
  stats: [
    { value: '18+', label: 'Yil Deneyim' },
    { value: '5', label: 'Akademik Yayin' },
    { value: '10+', label: 'Ekip Üyesi' },
  ],
  publications: [
    { year: '2020', type: 'Makale', title: 'Türkiye Bina Deprem Yönetmeligine Göre Mevcut Betonarme Binanin Performansinin Ve Zemin Etkilesiminin Degerlendirilmesi', journal: 'Bilecik Seyh Edebali Üniversitesi Fen Bilimleri Dergisi, 7(2), 1004-1014', doi: '10.35193/bseufbd.727437' },
    { year: '2021', type: 'Kongre', title: 'Farkli Kat Adetlerine Sahip Betonarme Yapilarin Dogrusal Olmayan Statik Itme Analizine Göre Tasarim Sonuçlarinin TBDY 2019 Kapsaminda Degerlendirilmesi', journal: 'Uluslararasi Mühendislik ve Doga Bilimleri Çalismalari Kongresi (ICENSS2021)', doi: '' },
    { year: '2021', type: 'Makale', title: 'Evaluation of The Performance Of An Existing Reinforced Concrete Grandstand According To TBDY 2019', journal: 'MAS Journal of Applied Sciences, 6(2), 433-445', doi: '10.52520/masjaps.77' },
    { year: '2021', type: 'Makale', title: 'Comparison of Contract Types for Turnkey Lump Sum-Unit Price Proposal Procedure in Repair-Renovation Tenders', journal: 'MAS Journal of Applied Sciences, 6(1), 186-193', doi: '10.52520/masjaps.70' },
    { year: '2021', type: 'Tez', title: 'Evaluation of the design results according to nonlinear static push-up analysis of two reinforced concrete structures with different floor quantities within the scope of TBDY 2019', journal: 'Yüksek Lisans Tezi - Istanbul Aydin Üniversitesi', doi: '' },
  ],
  platform_title: 'Kurumsal Is Yonetimi Platformu',
  platform_description: 'Görev takibi, ihale yönetimi, ödenek kontrolü, hakedis takibi ve daha fazlasi tek platformda.',
  contact_email: 'turna.cagatay@gmail.com',
  contact_phone: '+90 554 829 11 87',
  contact_instagram: 'https://www.instagram.com/cgtytrn',
  contact_instagram_handle: '@cgtytrn',
  contact_linkedin: 'https://www.linkedin.com/in/cagatayturna',
  contact_linkedin_handle: 'cagatayturna',
  contact_location: 'Istanbul, Türkiye',
  footer_text: '2026 Cagatay Turna. Tüm haklari saklidir.'
};

const HomePage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [c, setC] = useState(DEFAULTS);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    axios.get(`${API}/settings/homepage`).then(res => {
      if (res.data && res.data.exists !== false) {
        const merged = { ...DEFAULTS };
        Object.keys(res.data).forEach(k => {
          if (res.data[k] !== null && res.data[k] !== undefined) merged[k] = res.data[k];
        });
        setC(merged);
      }
    }).catch(() => {});
  }, []);

  const scrollTo = (id) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      {/* Navbar */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#0a0a0a]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <a href="/" className="text-xl font-light tracking-widest text-white hover:text-amber-400 transition-colors">
            {(c.hero_name || '').toUpperCase()} {(c.hero_surname || '').toUpperCase()}
          </a>
          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollTo('hero')} className="text-sm tracking-wider text-gray-300 hover:text-white transition-colors">ANASAYFA</button>
            <button onClick={() => scrollTo('about')} className="text-sm tracking-wider text-gray-300 hover:text-white transition-colors">HAKKIMDA</button>
            <button onClick={() => scrollTo('publications')} className="text-sm tracking-wider text-gray-300 hover:text-white transition-colors">YAYINLARIM</button>
            <button onClick={() => scrollTo('contact')} className="text-sm tracking-wider text-gray-300 hover:text-white transition-colors">ILETISIM</button>
            <button onClick={() => user ? navigate('/dashboard') : navigate('/login')} className="text-sm tracking-wider bg-amber-600 hover:bg-amber-700 text-white px-5 py-2 rounded transition-colors">KURUMSAL IS YONETIMI</button>
            {user?.is_admin && (
              <button onClick={() => navigate('/site-admin')} className="text-sm tracking-wider bg-gray-700 hover:bg-gray-600 text-white px-5 py-2 rounded transition-colors">ADMIN PANEL</button>
            )}
          </div>
          <button onClick={() => setMenuOpen(!menuOpen)} className="md:hidden text-white p-2">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {menuOpen ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /> : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />}
            </svg>
          </button>
        </div>
        {menuOpen && (
          <div className="md:hidden bg-[#0a0a0a]/98 border-t border-gray-800 px-6 py-4 space-y-3">
            <button onClick={() => scrollTo('hero')} className="block w-full text-left text-gray-300 hover:text-white py-2">ANASAYFA</button>
            <button onClick={() => scrollTo('about')} className="block w-full text-left text-gray-300 hover:text-white py-2">HAKKIMDA</button>
            <button onClick={() => scrollTo('publications')} className="block w-full text-left text-gray-300 hover:text-white py-2">YAYINLARIM</button>
            <button onClick={() => scrollTo('contact')} className="block w-full text-left text-gray-300 hover:text-white py-2">ILETISIM</button>
            <button onClick={() => { setMenuOpen(false); user ? navigate('/dashboard') : navigate('/login'); }} className="block w-full text-left text-amber-400 hover:text-amber-300 py-2 font-medium">KURUMSAL IS YONETIMI</button>
            {user?.is_admin && (<button onClick={() => { setMenuOpen(false); navigate('/site-admin'); }} className="block w-full text-left text-gray-400 hover:text-white py-2">ADMIN PANEL</button>)}
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section id="hero" className="relative min-h-screen flex items-center">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0a0a0a] via-[#111] to-[#0a0a0a]"></div>
        <div className="absolute inset-0 opacity-5" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(255,255,255,0.15) 1px, transparent 0)', backgroundSize: '40px 40px' }}></div>
        <div className="relative z-10 max-w-6xl mx-auto px-6 w-full">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="order-2 md:order-1">
              <div className="h-px w-16 bg-amber-500 mb-8"></div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-light leading-tight mb-6">
                <span className="text-gray-400">Merhaba, Ben</span><br />
                <span className="text-white font-medium">{c.hero_name}</span>{' '}
                <span className="text-amber-400 font-medium">{c.hero_surname}</span>
              </h1>
              <p className="text-lg text-gray-400 leading-relaxed mb-8 max-w-lg">{c.hero_subtitle}</p>
              <div className="flex flex-wrap gap-4">
                <button onClick={() => scrollTo('about')} className="px-8 py-3 border border-white/20 text-white hover:bg-white/5 transition-all tracking-wider text-sm">HAKKIMDA</button>
                <button onClick={() => user ? navigate('/dashboard') : navigate('/login')} className="px-8 py-3 bg-amber-600 hover:bg-amber-700 text-white transition-all tracking-wider text-sm">PLATFORMA GIRIS</button>
              </div>
            </div>
            <div className="order-1 md:order-2 flex justify-center">
              <div className="relative">
                <div className="absolute -inset-4 bg-gradient-to-br from-amber-500/20 to-transparent rounded-2xl blur-xl"></div>
                <img src="/cagatay-turna.png" alt={`${c.hero_name} ${c.hero_surname}`} className="relative w-80 md:w-96 rounded-2xl shadow-2xl object-cover" style={{ aspectRatio: '3/4', objectPosition: 'center top' }} />
                <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-[#0a0a0a] to-transparent rounded-b-2xl"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <svg className="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" /></svg>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-24 relative">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a] via-[#0f0f0f] to-[#0a0a0a]"></div>
        <div className="relative z-10 max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="h-px w-16 bg-amber-500 mx-auto mb-6"></div>
            <h2 className="text-3xl md:text-4xl font-light tracking-wider">HAKKIMDA</h2>
          </div>
          <div className="grid md:grid-cols-2 gap-16 items-start">
            <div>
              <p className="text-gray-400 leading-relaxed text-lg mb-6">{c.about_paragraph1}</p>
              <p className="text-gray-400 leading-relaxed text-lg mb-8">{c.about_paragraph2}</p>
              <h3 className="text-xl font-light tracking-wider text-amber-400 mb-4">Egitim</h3>
              <div className="space-y-3 mb-8">
                {(c.education || []).map((e, i) => (
                  <div key={i} className="flex gap-4 items-start">
                    <span className="text-xs text-amber-400 whitespace-nowrap mt-1 w-28">{e.year}</span>
                    <div><p className="text-white text-sm">{e.deg}</p><p className="text-gray-500 text-xs">{e.school}</p></div>
                  </div>
                ))}
              </div>
              <div className="grid grid-cols-3 gap-6">
                {(c.stats || []).map((stat, i) => (
                  <div key={i} className="text-center p-4 border border-gray-800 rounded-lg">
                    <div className="text-2xl font-bold text-amber-400">{stat.value}</div>
                    <div className="text-xs text-gray-500 mt-1">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="space-y-6">
              <h3 className="text-xl font-light tracking-wider text-amber-400 mb-4">Uzmanlik Alanlari</h3>
              {(c.expertise || []).map((item, i) => (
                <div key={i} className="p-5 border border-gray-800 rounded-lg hover:border-amber-500/30 transition-colors group">
                  <h4 className="text-white font-medium mb-1 group-hover:text-amber-400 transition-colors">{item.title}</h4>
                  <p className="text-sm text-gray-500">{item.desc}</p>
                </div>
              ))}
              <h3 className="text-xl font-light tracking-wider text-amber-400 mb-3 mt-8">Teknik Yazilimlar</h3>
              <div className="flex flex-wrap gap-2">
                {(c.technical_software || []).map((s, i) => (
                  <span key={i} className="text-xs bg-gray-800 text-gray-300 px-3 py-1.5 rounded border border-gray-700">{s}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Publications Section */}
      <section id="publications" className="py-24 relative">
        <div className="absolute inset-0 bg-[#0a0a0a]"></div>
        <div className="relative z-10 max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="h-px w-16 bg-amber-500 mx-auto mb-6"></div>
            <h2 className="text-3xl md:text-4xl font-light tracking-wider">YAYINLARIM</h2>
          </div>
          <div className="space-y-6">
            {(c.publications || []).map((pub, i) => (
              <div key={i} className="p-6 border border-gray-800 rounded-lg hover:border-amber-500/30 transition-colors group flex gap-6">
                <div className="flex-shrink-0 text-center">
                  <div className="text-2xl font-bold text-amber-400">{pub.year}</div>
                  <div className={`text-xs mt-1 px-2 py-0.5 rounded ${pub.type === 'Makale' ? 'bg-blue-900/50 text-blue-300' : pub.type === 'Tez' ? 'bg-purple-900/50 text-purple-300' : 'bg-green-900/50 text-green-300'}`}>{pub.type}</div>
                </div>
                <div>
                  <h3 className="text-white font-medium mb-1 group-hover:text-amber-400 transition-colors">{pub.title}</h3>
                  <p className="text-sm text-gray-500">{pub.journal}</p>
                  {pub.doi && <p className="text-xs text-amber-600 mt-1">DOI: {pub.doi}</p>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Platform CTA Section */}
      <section className="py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-amber-900/20 via-amber-800/10 to-amber-900/20"></div>
        <div className="absolute inset-0 bg-[#0a0a0a]/80"></div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-light tracking-wider mb-4">{c.platform_title}</h2>
          <p className="text-gray-400 text-lg mb-8 max-w-2xl mx-auto">{c.platform_description}</p>
          <button onClick={() => user ? navigate('/dashboard') : navigate('/login')} className="px-10 py-4 bg-amber-600 hover:bg-amber-700 text-white transition-all tracking-wider text-sm inline-flex items-center gap-3">
            PLATFORMA GIRIS YAP
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
          </button>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-24 relative">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a] via-[#0f0f0f] to-[#0a0a0a]"></div>
        <div className="relative z-10 max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="h-px w-16 bg-amber-500 mx-auto mb-6"></div>
            <h2 className="text-3xl md:text-4xl font-light tracking-wider">ILETISIM</h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-6 max-w-4xl mx-auto">
            <a href={`mailto:${c.contact_email}`} className="text-center p-6 border border-gray-800 rounded-lg hover:border-amber-500/30 transition-colors group">
              <svg className="w-8 h-8 mx-auto mb-3 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
              <p className="text-sm text-gray-400 group-hover:text-white transition-colors">{c.contact_email}</p>
            </a>
            <a href={`tel:${c.contact_phone?.replace(/\s/g, '')}`} className="text-center p-6 border border-gray-800 rounded-lg hover:border-amber-500/30 transition-colors group">
              <svg className="w-8 h-8 mx-auto mb-3 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
              <p className="text-sm text-gray-400 group-hover:text-white transition-colors">{c.contact_phone}</p>
            </a>
            <a href={c.contact_instagram} target="_blank" rel="noopener noreferrer" className="text-center p-6 border border-gray-800 rounded-lg hover:border-amber-500/30 transition-colors group">
              <svg className="w-8 h-8 mx-auto mb-3 text-amber-400" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
              <p className="text-sm text-gray-400 group-hover:text-white transition-colors">{c.contact_instagram_handle}</p>
            </a>
            <a href={c.contact_linkedin} target="_blank" rel="noopener noreferrer" className="text-center p-6 border border-gray-800 rounded-lg hover:border-amber-500/30 transition-colors group">
              <svg className="w-8 h-8 mx-auto mb-3 text-amber-400" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              <p className="text-sm text-gray-400 group-hover:text-white transition-colors">{c.contact_linkedin_handle}</p>
            </a>
            <div className="text-center p-6 border border-gray-800 rounded-lg">
              <svg className="w-8 h-8 mx-auto mb-3 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
              <p className="text-sm text-gray-400">{c.contact_location}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 border-t border-gray-800/50">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <p className="text-sm text-gray-600">&copy; {c.footer_text}</p>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
